export default __webpack_public_path__ + "static/media/ChallengePDF.4885aac9.png";